import { render } from "./TwoColumnSection.vue?vue&type=template&id=577fdb63"
import script from "./TwoColumnSection.vue?vue&type=script&lang=js"
export * from "./TwoColumnSection.vue?vue&type=script&lang=js"

import "./TwoColumnSection.vue?vue&type=style&index=0&id=577fdb63&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__